export const SUPPLIER_OPTIONS_STORAGE_KEY = 'baochau.portal.supplier-options.changed';

const listeners = new Set();
let initialized = false;
let revision = 0;
let storedSignal = null;
let lastResumeAt = null;

const readStoredSignal = () => {
  try {
    return window.localStorage.getItem(SUPPLIER_OPTIONS_STORAGE_KEY);
  } catch (_) {
    return null;
  }
};

const notifyListeners = () => {
  listeners.forEach((listener) => {
    try {
      listener();
    } catch (_) {
      // Lỗi tải lại danh sách không làm thao tác lưu nhà cung cấp thất bại.
    }
  });
};

const receiveSignal = (signal) => {
  if (signal === storedSignal) return false;
  storedSignal = signal;
  revision += 1;
  return true;
};

const initialize = () => {
  if (initialized || typeof window === 'undefined') return;
  initialized = true;
  storedSignal = readStoredSignal();

  window.addEventListener('storage', (event) => {
    if (event.key === SUPPLIER_OPTIONS_STORAGE_KEY && receiveSignal(event.newValue)) {
      notifyListeners();
    }
  });

  const resume = () => {
    if (document.hidden) return;
    const changed = receiveSignal(readStoredSignal());
    const now = Date.now();
    // Focus và visibilitychange thường đi cùng nhau khi quay lại một tab.
    if (!changed && lastResumeAt !== null && now - lastResumeAt < 500) return;
    lastResumeAt = now;
    notifyListeners();
  };
  window.addEventListener('focus', resume);
  document.addEventListener('visibilitychange', resume);
};

export const getSupplierOptionsRevision = () => {
  initialize();
  return revision;
};

export const subscribeSupplierOptionsRefresh = (listener) => {
  initialize();
  listeners.add(listener);
  return () => listeners.delete(listener);
};

export const invalidateSupplierOptions = () => {
  initialize();
  revision += 1;
  storedSignal = `${Date.now()}:${Math.random()}`;
  if (typeof window !== 'undefined') {
    try {
      window.localStorage.setItem(SUPPLIER_OPTIONS_STORAGE_KEY, storedSignal);
    } catch (_) {
      // Tab hiện tại vẫn tải lại được khi trình duyệt chặn localStorage.
    }
  }
  notifyListeners();
};
